module.exports = __webpack_public_path__ + "res/Roboto-Bold-webfont.ttf?76c8e70ec853e77a250440d73dc4544f";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Bold-webfont.ttf
// module id = 24
// module chunks = 0